import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  min-height: calc(100vh - 200px);
  max-width: 1300px;
  margin: 60px auto 0;
  padding: 1rem;

  @media only screen and (min-width: 600px) {
    margin: 60px auto 0 6rem;
  }
`
export const HeaderCard = styled.div`
  h1 {
    font-size: 24px;
    line-height: 120%;
  }
  @media only screen and (min-width: 800px) {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 6rem);
  }
`
export const Search = styled.div`
  // background: #fff;
  // box-shadow: 0px 7px 24px -5px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  width: 100%;
  max-width: 20rem;
  margin: 2rem 0 2rem auto;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

  .svgContainer {
    cursor: pointer;
  }

  svg {
    height: 1rem;
    margin-right: 0.5rem;
    color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
  }

  input {
    border: none;
    background: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    width: 100%;
    font-size: 1.125rem;

    &::placeholder {
      color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
    }
  }
`

export const EmptyText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;

  .empty-text {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    /* or 25px */

    display: flex;
    align-items: center;
    text-align: center;

    /* Dark Gray/100 */

    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }

  .loading {
    -webkit-animation: breathing 5s ease-out infinite normal;
    animation: breathing 5s ease-out infinite normal;
  }

  @-webkit-keyframes breathing {
    0% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }

    25% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }

    60% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }

    100% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
  }

  @keyframes breathing {
    0% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }

    25% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }

    60% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }

    100% {
      -webkit-transform: scale(0.9);
      -ms-transform: scale(0.9);
      transform: scale(0.9);
    }
  }
`

export const BackButton = styled.button`
  background: transparent;
  border: none;
  margin: 2rem auto 0 0;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 0.875rem;
  line-height: 1rem;
  font-weight: 700;

  svg {
    margin-right: 0.4rem;
  }
`

export const Card = styled.div`
  @media only screen and (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
  }
`
export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 18rem;
  max-width: 40rem;
  width: auto;
  background-color: ${({ theme }) => `rgb(${theme.background.high})`};
  margin-bottom: 0.5rem;
  border: 1.5px solid #e2e2e2;
  border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};
  box-sizing: border-box;
  border-radius: 20px;
  span {
    margin: 0.5rem;
    margin-left: 0;
    font-size: 16px;
  }
`
export const TitleCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => `1px solid rgb(${theme.grayscale[200]})`};
  line-height: 136%;
  font-size: 18px;
  margin-left: 1rem;
  span {
    width: 7rem;
    text-align: center;
    color: ${({ theme }) => `rgb(${theme.green[200]})`};
    background: ${({ theme }) => `rgb(${theme.green[600]})`};
    border-radius: 3.25px;
    font-weight: bold;
    font-size: 0.87rem;
  }
  .type {
    color: ${({ theme }) => `rgb(${theme.purple[100]})`};
    background: ${({ theme }) => `rgb(${theme.purple[700]})`};
  }
  h2 {
    font-size: 1.35rem;
  }
`
export const ContentCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => `rgba(${theme.background.low}, 0.5)`};
  margin: 0;

  .text-doubt {
    font-size: 0.84rem;
    font-weight: 500;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    margin: 1rem;
    margin-top: 0;
    margin-bottom: 1rem;
  }

  button {
    background: transparent;
    border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};
    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.8)`};
    padding: 0.5rem 1rem;
    margin: 0 auto 0 1rem;
    border-radius: 4px;
    font-weight: 700;
  }

  @media only screen and (min-width: 600px) {
    .text-doubt {
      max-width: 32.43rem;
      height: 4rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      margin: 2rem;
      margin-top: 0;
      margin-bottom: 1rem;
    }
  }
`
export const HeaderContendCard = styled.div`
  margin: 1rem;
  .text-doubt {
    font-size: 1rem;
    line-height: 1.375rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    margin: 0;
    margin-bottom: 1rem;
  }

  p {
    display: flex;
    align-items: center;
    font-size: 13.5px;
    line-height: 136%;
    margin: 0.5rem 0 0.5rem 0;

    strong {
      margin-right: 0.5rem;
    }
  }
  @media only screen and (min-width: 600px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;
  }
`
export const FooterCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 1rem;
  margin-top: 0;
  margin-bottom: 1rem;
  button {
    margin-top: 1rem;
    margin-left: 0.5rem;
    padding: 0.25rem;
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
    border: 1px solid ${({ theme }) => `rgb(${theme.primary.base})`};
    border-radius: 4px;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.375rem;
    background: transparent;
    width: 100%;
  }
  p {
    margin: 0.5rem;
    margin-left: 0;
    font-size: 14px;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]}, 0.8)`};
    font-weight: 500;
  }
  @media only screen and (min-width: 600px) {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    max-width: 40rem;
    margin: 1rem;
    button {
      width: 10rem;
    }
    p {
      width: 90%;
    }
  }
`

export const DoubtType = styled.div`
  margin-top: 1rem;
  padding: 0.25rem;
  color: ${({ theme }) => `rgb(${theme.primary.base})`};
  border: 1px solid ${({ theme }) => `rgb(${theme.primary.base})`};
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.375rem;
  background: transparent;
  width: 6rem;
  text-align: center;
`
